import { Stack, Grid, Typography, Box } from "@mui/material";
import { FC } from "react";
import SalifySvgIconString from "../../icon/svg/svg-icon-string";
import { StatsBlock as StatsBlockType } from "../types";

interface StatsBlockProps {
  stats: StatsBlockType;
  theme: string;
}

const StatsBlock: FC<StatsBlockProps> = ({ stats, theme }) => {
  const getThemeStyles = () => {
    switch (theme) {
      case "haianh":
        return {
          value: {
            fontSize: { xs: 28, md: 36 },
            fontWeight: 700,
            color: "#FFC107",
            lineHeight: 1,
          },
          label: {
            fontSize: 12,
            color: "#666",
            textAlign: "center" as const,
            lineHeight: 1.3,
          },
        };
      case "nova-press":
        return {
          value: {
            fontSize: { xs: 24, md: 32 },
            fontWeight: 700,
            color: "#01a750",
            lineHeight: 1,
          },
          label: {
            fontSize: 12,
            color: "#666",
            textAlign: "center" as const,
            lineHeight: 1.3,
          },
        };
      default:
        return {
          value: {
            fontSize: { xs: 20, md: 28 },
            fontWeight: 700,
            color: "#333",
            lineHeight: 1,
          },
          label: {
            fontSize: 12,
            color: "#666",
            textAlign: "center" as const,
            lineHeight: 1.3,
          },
        };
    }
  };

  const themeStyles = getThemeStyles();
  const isGrid = stats.layout === "grid";
  const columns = stats.columns || 3;

  if (isGrid) {
    return (
      <Grid container spacing={2} {...stats.stackProps}>
        {stats.stats.map((stat, index) => (
          <Grid item xs={12 / columns} key={index}>
            <Stack alignItems="center" spacing={0.5}>
              {stat.icon && <SalifySvgIconString svgString={stat.icon} fontSize={24} />}
              <Typography
                variant="h4"
                sx={{
                  ...themeStyles.value,
                  ...stat.cssProps?.value,
                }}
              >
                {stat.value}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  ...themeStyles.label,
                  ...stat.cssProps?.label,
                }}
              >
                {stat.label}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Stack
      direction="row"
      spacing={3}
      divider={
        <Box
          sx={{
            width: 1,
            height: 40,
            backgroundColor: "#e0e0e0",
          }}
        />
      }
      {...stats.stackProps}
    >
      {stats.stats.map((stat, index) => (
        <Stack key={index} alignItems="center" spacing={0.5} sx={{ flex: 1 }}>
          {stat.icon && <SalifySvgIconString svgString={stat.icon} fontSize={24} />}
          <Typography
            variant="h4"
            sx={{
              ...themeStyles.value,
              ...stat.cssProps?.value,
            }}
          >
            {stat.value}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              ...themeStyles.label,
              ...stat.cssProps?.label,
            }}
          >
            {stat.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default StatsBlock;
